module.exports = __webpack_public_path__ + "media/images/redesign-images/essentials/elegance-c1e66f464446c64a242695240d4b1dc6.jpg";